import { createUseStyles } from '@glu/theming';

export const nativeStyles = ({ spacing: { unit } }) => ({
  workspace: {
    display: 'flex',
    flexFlow: 'row wrap',
    padding: `0 0 ${unit * 5}px`
  },
  locked: {
    paddingTop: unit * 5
  }
});

export default createUseStyles(nativeStyles);
